const local = false;
const configs = {
    baseUrl: 'api.picksixty.com'
}
if(local){
    configs.baseUrl = 'localhost:8888'
}
export { configs }